import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from '../project/project.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Geo } from '../models';
import { Observable } from 'rxjs';
import { EditDeviceService } from '../services/edit-device.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { GoogleMapService, Position } from '../google-map.service';
import { toggleModalById } from '../utils';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-device-initial-location',
  templateUrl: './device-initial-location.component.html',
  styleUrls: ['./device-initial-location.component.css']
})
export class DeviceInitialLocationComponent implements OnInit {

  deviceLocation: any;
  deviceId;
  projectId;
  latitude;
  longitude;
  currentDeviceId;
  fromDate;
  toDate;
  infoWindow: any;
  info: string = '';
  zoom = 14;
  position: Position | null = null;
  constructor( private route: ActivatedRoute, private router: Router, private editDeviceService: EditDeviceService, 
    private spinner: NgxSpinnerService, private geomapService: GoogleMapService,   private toaster: ToastrService,) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.currentDeviceId = params['deviceId'];
      this.projectId = params['projectId'];
    });
    const isDatasaved = this.editDeviceService.isFormSaved();

    // If data is not saved, show an error message and redirect to the device page
    if(!isDatasaved){
      this.toaster.error( 'Something went wrong', 'Error!');
      this.router.navigate([`/`]);
    }
    this.getCurrentPosition();

  }
  getCurrentPosition(){
    this.spinner.show();
  
    this.geomapService.getCurrentLocation().subscribe((location) => {
      if (location) {
        this.latitude = location.lat;
        this.longitude = location.lng;
        this.deviceLocation = location;
        console.log('Final Location:', this.deviceLocation);
      }
      this.spinner.hide(); // Hide spinner only after location is set
      if(this.deviceLocation.accuracy > 200){
        this.info="Location accuracy is poor. Please try again.";
        toggleModalById('showInfo');
       }
      else{
        this.info="";
      }
  
    }, (error) => {
      console.error('Error getting location:', error);
      if (error.code === error.PERMISSION_DENIED) {
        this.info = "Permission denied. Please enable location services.";
        toggleModalById('showInfo');
      }

      this.spinner.hide(); // Ensure spinner hides even on error
    });

  }

  markerDragEnd($event: any) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
  }
  confirmLocation() {
    this.editDeviceService.saveLocation(this.deviceLocation);
    this.router.navigate(['/device', this.projectId]);
  }
  SelectPinnedLocation() {
    this.geomapService.reverseGeocode(this.latitude, this.longitude).subscribe(
      (response: any) => {
        let address = response.results.length > 0 ? response.results[0].formatted_address : '';
        this.deviceLocation = { lat: this.latitude, lng: this.longitude, address };
      }
    )
    toggleModalById('AddressModal');
  }


  closeModal(id){
    toggleModalById(id);
  }
  goBack() {
    this.router.navigate(['/device', this.projectId]);
  }

  changeZoom(zoom) {
    this.zoom = zoom;
  }

}
